import { X } from "lucide-react";

export function Modal({ open, onClose, title, children, wide = false }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center p-4 overflow-y-auto" data-testid="admin-modal">
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative bg-[#181A20] border border-amber-500/20 rounded-2xl w-full ${wide ? "max-w-3xl" : "max-w-lg"} my-8 shadow-2xl`}>
        <div className="flex items-center justify-between p-5 border-b border-white/5">
          <h3 className="font-semibold text-white">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-white" data-testid="modal-close"><X size={20} /></button>
        </div>
        <div className="p-5 max-h-[75vh] overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return <div><label className="label-lux">{label}</label><div className="mt-1.5">{children}</div></div>;
}

export function AdminTitle({ title, action }) {
  return (
    <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
      <h1 className="text-2xl font-extrabold text-white">{title}</h1>
      {action}
    </div>
  );
}
